import { render, staticRenderFns } from "./our-rooms.vue?vue&type=template&id=56caddc1&"
import script from "./our-rooms.vue?vue&type=script&lang=js&"
export * from "./our-rooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports